/**
 * 이미지 경로 헬퍼 함수
 * PHP의 img_path() 함수와 동일한 동작
 * 
 * @param {string} path - 이미지 경로 (예: 'main-hero/main-1.jpg')
 * @param {boolean} cache - 캐시 버스팅 사용 여부
 * @returns {string} 완전한 이미지 경로
 */
export function imgPath(path, cache = false) {
    const basePath = '/resource/images';
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    const fullPath = `${basePath}/${cleanPath}`;
    
    if (cache) {
        return `${fullPath}?v=${Date.now()}`;
    }
    
    return fullPath;
}
